import "./InstructionalVideoGrid.scss"
import { useNavigate } from "react-router-dom"
import InstructionalVideosApi from "../api/instructionalVideosApi"
import { InstructionalVideoDto, WatchState } from "../model/InstructionalVideoDtos"
import { useEffect, useState } from "react"
import { t } from "i18next"
import { Color } from "../../../core/const/const"
import { queryBuilder } from "../../../core/api/queryBuilder"
import { Card, Col, LoadIndicator, Row } from "../../../core/components"

interface InstructionalVideosGridProps {
    selectedWatchStates: Set<WatchState>
}

export default function InstructionalVideosGrid(props: InstructionalVideosGridProps) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const [instructionalVideos, setInstructionalVideos] = useState<InstructionalVideoDto[]>([])

    useEffect(() => {
        fetchData()
    }, [props.selectedWatchStates])

    const fetchData = async () => {
        setLoading(true)

        let query: string
        if (props.selectedWatchStates.size === 0) {
            query = queryBuilder.pagination(1, 25)
        } else {
            query = queryBuilder.build({'watchState': [...props.selectedWatchStates]}, undefined, undefined, 1, 25)
        }
        const instructionalVideos = (await InstructionalVideosApi.getVideos(query)).items
        setInstructionalVideos(instructionalVideos)
        setLoading(false)
    }

    const goToVideo = (id: number) => {
        navigate(`/instructional-videos/${id}`)
    }

    const getVideoThumbnailUrl = (url: string) => {
        const youtubeId = url.includes("youtube")
            ? url.split("watch?v=")[1]
            : url.split(".be/")[1]

        return (`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`)
    }

    function watchStateToColor(watchState: WatchState): string {
        switch (watchState) {
            case WatchState.Not:
                return Color.scheduled
            case WatchState.Partially:
                return Color.active
            case WatchState.Fully:
                return Color.finished
        }
    }

    const watchStateToLabelText = (watchState: WatchState) => {
        switch (watchState) {
            case WatchState.Not:
                return t("NotWatched")
            case WatchState.Partially:
                return t("PartiallyWatched")
            case WatchState.Fully:
                return t("FullyWatched")
        }
    }

    return <>
        <LoadIndicator loading={loading} />
        <Card padding={1} minHeight={300}>
            <Row grow={0} className="spacing">
                {instructionalVideos.map(e => (
                    <Col key={e.idInstructionalVideo} grow={0} className="center clickable instructional-video" width="330px">
                        <Card className="instructional-video-grid-card border-radius-small" margin={"0"} width="330px" height="250px">
                            <div className="thumbnail-container" onClick={() => goToVideo(e.idInstructionalVideo)} style={{ position: "relative" }}>
                                <img
                                    src={getVideoThumbnailUrl(e.url)}
                                    alt=""
                                    style={{ width: "100%", height: "100%", objectFit: "fill" }}
                                />
                                <span
                                    className={`status-pill ${WatchState[e.watchState!].toLowerCase()}`} // optional: dynamic class for color
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "6px",
                                        padding: "4px 10px",
                                        borderRadius: "20px",
                                        backgroundColor: watchStateToColor(e.watchState!),
                                        backdropFilter: "blur(8px)",
                                        WebkitBackdropFilter: "blur(8px)",
                                        color: "white",
                                        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                    }}
                                >
                                    {watchStateToLabelText(e.watchState!)}
                                </span>
                            </div>
                        </Card>
                        <span className="title">{e.title}</span>
                    </Col>
                ))}
            </Row>

        </Card>
    </>
}
